import { useState, useEffect } from 'react';
import { dolarService } from '../services/dolarService';

export const useDolarBlue = () => {
  const [cotizacion, setCotizacion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCotizacion = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await dolarService.getDolarBlue();
        setCotizacion(data);
      } catch (err) {
        setError(err.message);
        console.error('Error en useDolarBlue:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCotizacion();

    // Actualizar cada 5 minutos
    const interval = setInterval(fetchCotizacion, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  // Función helper para convertir ARS a USD
  const convertArsToUsd = (arsAmount) => {
    if (!cotizacion || !arsAmount) return null;
    return Math.round(arsAmount / cotizacion.venta);
  };

  return {
    cotizacion,
    loading,
    error,
    convertArsToUsd
  };
};

export default useDolarBlue;